import React, { useState, useEffect } from "react";

export default function ValueCard({ icon, title, description }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`value-item ${visible ? "visible" : ""}`}>
      <div className="value-icon">{icon}</div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}
